import { showToast } from '../../components/toast-notification';

export const toastConfigSaved = () =>
  showToast({ message: 'Your config has been successfully saved.', type: 'success' });

export const toastConfigSaveError = () =>
  showToast({
    message: 'Something went wrong. We were unable to save your config, please try again.',
    type: 'error',
  });

export const toastConfigUpdated = () =>
  showToast({ message: 'Your config has been successfully updated.', type: 'success' });

export const toastConfigUpdateError = () =>
  showToast({
    message: 'Something went wrong. We were unable to update your config, please try again.',
    type: 'error',
  });

export const toastConfigDeleted = () =>
  showToast({ message: 'Your config has been successfully deleted.', type: 'success' });

export const toastConfigDeleteError = () =>
  showToast({
    message: 'Something went wrong. We were unable to delete your config, please try again.',
    type: 'error',
  });

export const toastBacktestRunError = () =>
  showToast({
    message: 'Something went wrong. We were unable to run the backtest, please try again.',
    type: 'error',
  });
